/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  HangarPublic,
  PublicWishlistParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Your Wishlist
 */
export const publicWishlist = (
    username: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicWishlistParams>,
 signal?: AbortSignal
) => {
      username = toValue(username);
params = toValue(params);

      return axiosClient<HangarPublic>(
      {url: `/public/wishlists/${username}`, method: 'GET',
        params, signal
    },
      );
    }




export const getPublicWishlistQueryKey = (username: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicWishlistParams>,) => {
    return [
    'public','wishlists',username, ...(params ? [params] : [])
    ] as const;
    }


export const getPublicWishlistQueryOptions = <TData = Awaited<ReturnType<typeof publicWishlist>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(username: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicWishlistParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicWishlist>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicWishlistQueryKey(username,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicWishlist>>> = ({ signal }) => publicWishlist(username,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(username) !== null && toValue(username) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicWishlist>>, TError, TData>
}

export type PublicWishlistQueryResult = NonNullable<Awaited<ReturnType<typeof publicWishlist>>>
export type PublicWishlistQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Your Wishlist
 */

export function usePublicWishlist<TData = Awaited<ReturnType<typeof publicWishlist>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 username: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicWishlistParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicWishlist>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicWishlistQueryOptions(username,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






